module.exports = __webpack_public_path__ + "static/online_treatment_3-59c6549254450371159ee8e40722015f.png";